<template>
  <div>
    <wc-section-title title='Estimates'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'estimates-base',
  computed: {
    estimatesMenu () {
      return [
        {
          title: this.$store.state.icons.modules.estimates.title,
          icon: this.$store.state.icons.modules.estimates.icon,
          route: { name: 'EstimatesDashboard' }
        },
        {
          title: 'Ready to sell',
          icon: 'mdi-license',
          route: { name: 'ReadyToSell' }
        },
        {
          title: 'Sold',
          icon: 'mdi-bookmark-check-outline',
          route: { name: 'Sold' }
        },
        {
          title: 'Archived',
          icon: 'mdi-archive',
          route: { name: 'Archived' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Estimates Menu')
    this.$store.dispatch('loadMainMenu', this.estimatesMenu)
  }
}
</script>
